import React from "react";
import { Link } from "react-router-dom";
import SsoLoginCallBack from "Utils/SsoLoginCallBack";



const SsoCallBackApple = () => {
    SsoLoginCallBack("apple");
    return(
        <>
        </>
    )
}

export default SsoCallBackApple;